const quiz = {
  sampleBotContent: {
    schemaVersion: 1,
    templateType: "quiz",
    items: [
      { id: "q1", question: "Welcher Tag kommt vor Dienstag? ", answers: ["Montag"], image: null },
      { id: "q2", question: "Welcher Tag kommt vor Freitag? ", answers: ["Donnerstag"], image: null },
      { id: "q3", question: "Welcher Tag kommt nach Mittwoch? ", answers: ["Donnerstag"], image: null },
      { id: "q4", question: "Welcher Tag kommt vor Samstag? ", answers: ["Freitag"], image: null },
      { id: "q5", question: "Welcher Tag kommt nach Samstag? ", answers: ["Sonntag"], image: null },
      { id: "q6", question: "Welcher Tag kommt vor Sonntag? ", answers: ["Samstag"], image: null },
      { id: "q7", question: "Welcher Tag kommt nach Sonntag? ", answers: ["Montag"], image: null },
      { id: "q8", question: "Welcher Tag kommt vor Montag? ", answers: ["Dienstag"], image: null },
      { id: "q9", question: "Welcher Tag kommt nach Freitag? ", answers: ["Samstag"], image: null },
      { id: "q10", question: "Welcher Tag kommt vor Freitag? ", answers: ["Donnerstag"], image: null },
    ],
  },
  botId: "nualang.quiz.0.0.1",
  botName: "quiz",
  description: "quiz_desc",
  difficulty: "ALL",
  learnLang: "german",
  name: "Kasper",
  botAvatar:
    "https://images.nualang.com/eyJidWNrZXQiOiJudWFsYW5nLWltYWdlcy1wcm9kIiwia2V5IjoiYXZhdGFycy8wLW51YWxhLTAwNC5wbmcifQ==",
  picture: `${process.env.REACT_APP_API}/image-creator/848/480/691f89/ffffff/fa-question-circle?fontSize=200`,
  creatorInstructions: "",
  studentInstructions: `# Willkommen zum Quiz
Moderiert von Kasper.

Kennst du die Wochentage?

Sag "Hallo" zu Joanna, um zu beginnen.`,
  voice: "Kasper",
  versionQuestion: "Wie viele Fragen möchten Sie in dieser Vorlage haben?",
};

export default quiz;
